import React, { useState, useRef, useEffect } from "react";
import { useAuth } from "hooks/useAuth";
import { useNavigate } from "react-router-dom";

export const Navbar = ({ handleLoginClick }) => {
  const { isLogged, getUserData, logout } = useAuth();
  const user = getUserData();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  const getInitials = (name = "") =>
    name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();

  const onLogout = () => {
    logout();
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="landing-header">
      <div className="landing-header-content">

        <div className="logo" onClick={() => navigate("/")}>
          <img
            src="https://cdn2.paraty.es/mariabonita-corpo/images/15cba433451f2bd=s250"
            height="46"
            alt="María Bonita Logo"
          />
        </div>

        {isLogged ? (
          <div className="user-container" ref={dropdownRef}>
            <div className="user-name">{user?.nombre}</div>

            <div className="user-avatar">
              {getInitials(user?.nombre)}
            </div>

            <button
              className="gear-btn"
              onClick={() => setOpen(!open)}
            >
              <i className="bi bi-gear-fill"></i>
            </button>

            {open && (
              <div className="dropdown-menu-custom">
                <div
                  className="dropdown-item"
                  onClick={() => navigate("/profile")}
                >
                  <i className="bi bi-person"></i>
                  Perfil
                </div>

                <div
                  className="dropdown-item logout"
                  onClick={onLogout}
                >
                  <i className="bi bi-box-arrow-right"></i>
                  Cerrar Sesión
                </div>
              </div>
            )}
          </div>
        ) : (
          <button className="btn-login" onClick={handleLoginClick}>
            <i className="bi bi-box-arrow-in-right"></i>
            Iniciar Sesión
          </button>
        )}
      </div>
    </header>
  );
};
